export const generateExcel = (
  // TODO: this is the correct list type,
  //  list: (string | number | undefined)[][],
  list: any,
  title = "لیست تسویه‌ها",
  fileName = "PayPing-cashout.xlsx"
): void => {
  import(/* webpackPreload: true */ "xlsx").then(({ utils, writeFile }) => {
    const listWorksheet = utils.aoa_to_sheet([list[0], ...list[1]]);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, listWorksheet, title);
    writeFile(workbook, fileName);
  });
};
